export default __webpack_public_path__ + "static/media/heart-rate.cbb0cc86.png";